import React, { useState } from 'react'

import useAxios, { mutate } from 'hooks/useAxios'
import { Dropdown, Segment } from 'semantic-ui-react'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import { toast } from 'libs/toast'

import ValidationStatusIcon from 'shared/components/ValidationStatusIcon'

export default function SurveyPushContactCustomFieldSetting({
  disabled,
  surveyIntegrationSetting,
  contactCustomFields,
  resyncContactFieldLoading,
}) {
  const defaultRatingCustomFieldId = surveyIntegrationSetting.additional_option.rating
  const [ratingCustomFieldId, setRatingCustomFieldId] = useState(defaultRatingCustomFieldId)
  const [showUpdateStatus, setShowUpdateStatus] = useState(false)
  const [isError, setIsError] = useState(false)
  const {
    fetch: updatePushContactCustomFieldSettingAPI,
    loading: updatePushContactCustomFieldSettingAPILoading,
  } = useAxios({
    url: `survey/survey-integration-setting/by-survey/${surveyIntegrationSetting.survey.token}/additional-option/`,
    method: 'patch',
    skip: true,
  })

  const saveUserActivityLog = useSaveUserActivityLog()

  /**
   *
   * @param {object} requestBody
   * @param {number} statusCode
   * @param {number} surveyId
   */
  function _saveUserActivityLog(requestBody, statusCode, surveyId) {
    const action = ACTION_NAME.edit_intercom_push_contact_custom_field
    const target = `sur_${surveyId}`
    saveUserActivityLog({
      action,
      target,
      statusCode,
      requestBody,
    })
  }

  function updatePushContactCustomFieldSetting(_, { value }) {
    setShowUpdateStatus(true)
    setRatingCustomFieldId(value)
    const data = {
      name: 'push_contact_custom_field',
      integration_type: 'intercom',
      option_name: 'rating',
      option_value: value,
    }
    updatePushContactCustomFieldSettingAPI({
      data,
    })
      .then((response) => {
        toast.success('Settings updated.')

        setIsError(false)
        mutate(
          'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_contact_custom_field'
        )
        _saveUserActivityLog(data, response.status, surveyIntegrationSetting.survey.id)
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        setRatingCustomFieldId(ratingCustomFieldId)
        setIsError(true)
        _saveUserActivityLog(data, error.response.status, surveyIntegrationSetting.survey.id)
      })
  }

  const options = [
    {
      key: 'null',
      text: 'Do not sync',
      value: null,
    },
    ...contactCustomFields.map((contactCustomField) => ({
      key: contactCustomField.id,
      text: contactCustomField.name,
      value: contactCustomField.id,
    })),
  ]

  function getValue() {
    if (disabled) {
      // TODO: return null because input will show do not sync when credential revoked
      return null
    } else {
      return ratingCustomFieldId
    }
  }

  return (
    <Segment>
      <div className="flex flex-wrap leading-none">
        <div className="self-center" style={{ flex: '320px' }}>
          <strong>{surveyIntegrationSetting.survey.name}</strong>
        </div>
        <ValidationStatusIcon
          isLoading={updatePushContactCustomFieldSettingAPILoading}
          isError={isError}
          suppressUntilFirstChange={!showUpdateStatus}
        />
        <Dropdown
          style={{ alignSelf: 'center' }}
          search
          selection
          value={getValue()}
          placeholder="Do not sync"
          options={options}
          disabled={
            disabled || updatePushContactCustomFieldSettingAPILoading || resyncContactFieldLoading
          }
          onChange={updatePushContactCustomFieldSetting}
          loading={resyncContactFieldLoading}
        />
      </div>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomPushContactCustomFieldIntegration/SurveyPushContactCustomFieldSetting.js